(() => {
  window.swinger = window.swinger || {};
  window.swinger.svg = {
    animatePath: (path, seconds = 2) => {
      const length = path.getTotalLength();
      // Clear any previous transition
      path.style.transition = 'none';
      // Set up the starting positions
      Object.assign(path.style, {
        strokeDasharray: `${length} ${length}`,
        strokeDashoffset: `${length}`,
      });
      // Trigger a layout so styles are calculated & the browser
      // picks up the starting position before animating
      path.getBoundingClientRect();
      // Define our transition
      Object.assign(path.style, {
        transitionProperty: 'stroke-dashoffset, opacity',
        transitionDuration: `${seconds}s`,
        transitionEasing: 'ease-in-out',
      });
      // Go!
      Object.assign(path.style, {
        strokeDashoffset: 0,
      });
    },
  };
})();
